import { render } from "./UploadFileConfirm.vue?vue&type=template&id=ecd99f32&scoped=true"
import script from "./UploadFileConfirm.vue?vue&type=script&lang=js"
export * from "./UploadFileConfirm.vue?vue&type=script&lang=js"

import "./UploadFileConfirm.vue?vue&type=style&index=0&id=ecd99f32&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecd99f32"]])

export default __exports__